import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dcd199c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header is-full" }
const _hoisted_2 = { class: "dropdown-trigger" }
const _hoisted_3 = { class: "selected-profile-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "dropdown-menu",
  class: "dropdown-menu dropdown-menu-container",
  role: "menu"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "dropdown-profile-image" }
const _hoisted_8 = { class: "dropdown-profile-image is-flex" }
const _hoisted_9 = { class: "dropdown-profile-name" }
const _hoisted_10 = { class: "icon-container" }
const _hoisted_11 = {
  key: 0,
  class: "network-icon-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("lukso-icon", {
  name: "wallet-outline",
  size: "medium"
}, null, -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]

import { ref, onMounted, nextTick, computed } from 'vue'
import { useRouter } from 'vue-router'
import browser from 'webextension-polyfill'

import { useAppStore } from '@/popup/store/AppStore'
import { InternalMethods } from '@/shared/apis/messages'
import NetworkIcon from '@/popup/components/shared/NetworkIcon.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { saveLastState } from '@/popup/storage/Database'
import ArrowDown from '@/assets/arrowdown.svg'
import ArrowUp from '@/assets/arrowup.svg'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { UNIVERSAL_EVERYTHING_URL } from '@/shared/config'
import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'

const BASE_CHAIN_ID = 8453
const BASE_TESTNET_CHAIN_ID = 84_532


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarMain',
  props: {
    handleChangeDropdown: { type: Function },
    dropdownIsOpen: { type: Boolean },
    isModalRoute: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const appStore = useAppStore()
const uiStore = useUIStore()

const currentProfile = computed(() => {
  return appStore.currentProfile
})

const connectedProfilesMap = computed(() => {
  if (uiStore.isPopup) {
    return {}
  }
  const profileMap: Record<string, boolean> = {}
  for (const app of appStore.authenticatedAppsByOrigin) {
    profileMap[app.profileAddress] = true
  }
  return profileMap
})

const dropdownAddresses = computed(() => {
  return appStore.dropdownAddresses.filter(
    profile => profile.address !== currentProfile.value?.address
  )
})

const networks = ref<NetworkInfoDBSchema[]>([])

onMounted(async () => {
  networks.value = await useGlobals().sendMessage({
    method: InternalMethods.GET_NETWORKS,
    payload: undefined,
  })
})

const showNetworkIcon = computed(() => networks.value.length > 1)

const goToNetworkSettings = async () => {
  await router.push({ path: '/settings' })
  await nextTick()
  const element = document.querySelector('#network')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

const networkName = computed(() => {
  return appStore.network.name
})

const handleChangeUser = async (address: string) => {
  const data = await useGlobals().sendMessage({
    method: InternalMethods.SWITCH_PROFILE,
    payload: { address },
  })
  await appStore.handleUserChange(data)
  await router.push({ path: appStore.lastPopupState?.path || '/home' })
  if (
    router.currentRoute.value.path === '/' ||
    router.currentRoute.value.path === '/home'
  ) {
    saveLastState({ path: '/' })
  }
  props.handleChangeDropdown(false)
}

const handleAddProfile = () => {
  props.handleChangeDropdown(false)
  router.push({ path: '/add-account' })
}

const handleClickSettings = () => {
  props.handleChangeDropdown(false)
  router.push({ name: 'settings' })
}

const handleWalletClick = async () => {
  props.handleChangeDropdown(false)
  browser.tabs.create({
    url: `${UNIVERSAL_EVERYTHING_URL}/${currentProfile.value?.address}?network=${appStore.network.id}`,
  })
  // TODO new wallet will open as part of extension
  // browser.tabs.create({
  //   url: `/external.html#/assets`
  // })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(`navbar is-fixed-top
    ${_ctx.dropdownIsOpen ? 'nav-open' : 'nav-close'}
    ${_ctx.isModalRoute ? 'navbar-background' : ''}`),
    role: "navigation",
    "aria-label": "main navigation",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownIsOpen ? _ctx.handleChangeDropdown(!_ctx.dropdownIsOpen) : null))
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["dropdown", _ctx.dropdownIsOpen ? 'is-active' : ''])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "profile-dropdown",
              "aria-haspopup": "true",
              "aria-controls": "dropdown-menu",
              onClick: _cache[0] || (_cache[0] = 
                event => {
                  event.stopPropagation()
                  _ctx.handleChangeDropdown(!_ctx.dropdownIsOpen)
                }
              )
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ProfilePicture, {
                  size: "small",
                  "frontend-profile": currentProfile.value
                }, null, 8 /* PROPS */, ["frontend-profile"])
              ]),
              _createVNode(UserName, {
                profile: currentProfile.value,
                "max-width": 160
              }, null, 8 /* PROPS */, ["profile"]),
              _createElementVNode("div", {
                class: _normalizeClass(["dot ml-1", 
                  connectedProfilesMap.value[currentProfile.value.address]
                    ? 'connected'
                    : ''
                ])
              }, null, 2 /* CLASS */),
              _createElementVNode("img", {
                class: "dropdown-icon",
                src: !_ctx.dropdownIsOpen ? _unref(ArrowDown) : _unref(ArrowUp)
              }, null, 8 /* PROPS */, _hoisted_4)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createVNode(Scroll, { class: "dropdown-content-fix" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropdownAddresses.value, ({ name, profilePicture, address }) => {
                  return (_openBlock(), _createElementBlock("div", { key: address }, [
                    _createElementVNode("button", {
                      class: "dropdown-item dropdown-item-button relative",
                      onClick: ($event: any) => (handleChangeUser(address))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(ProfilePicture, {
                          "frontend-profile": {
                        name,
                        address,
                        profilePicture,
                      },
                          size: "medium"
                        }, null, 8 /* PROPS */, ["frontend-profile"])
                      ]),
                      _createVNode(UserName, {
                        profile: { name, address },
                        address: address,
                        "max-width": 260,
                        "extra-class": "dropdown-profile-name"
                      }, null, 8 /* PROPS */, ["profile", "address"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["dot is-right", connectedProfilesMap.value[address] ? 'connected' : ''])
                      }, null, 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_6)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */), [
              [_vShow, dropdownAddresses.value.length > 0]
            ]),
            (
                !_unref(appStore).network.isCustom &&
                _unref(appStore).network.chainId != BASE_CHAIN_ID &&
                _unref(appStore).network.chainId != BASE_TESTNET_CHAIN_ID
              )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "dropdown-item dropdown-add-profile",
                  onClick: handleAddProfile
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(SvgIcon, {
                      name: "create-profile",
                      class: "add-profile-icon"
                    })
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('create_new_account.add_profile')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (showNetworkIcon.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(Tooltip, { value: networkName.value }, {
                default: _withCtx(() => [
                  _createVNode(NetworkIcon, { onClick: goToNetworkSettings })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["value"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", {
          class: "button is-text p-0",
          onClick: handleWalletClick
        }, _hoisted_13),
        _createElementVNode("button", {
          disabled: _ctx.$route?.name === 'settings',
          class: _normalizeClass(`button is-text p-0 ${
            _ctx.$route?.name === 'settings' ? 'active' : ''
          }`),
          onClick: handleClickSettings
        }, [
          _createVNode(SvgIcon, {
            name: "settings",
            color: "var(--neutral-20)",
            width: "24",
            height: "24"
          })
        ], 10 /* CLASS, PROPS */, _hoisted_14)
      ])
    ])
  ], 2 /* CLASS */))
}
}

})